import { axiosInstance as request } from '@api/rest.service'

const api = '/license-periods'

/**
 * @description GET /license-periods/create
 * @returns {AxiosPromise<any>}
 */
export const GET_LICENSE_PERIODS_CREATE = () => request.get(`${api}/create`)

/**
 * @description GET /license-periods/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_LICENSE_PERIOD = id => request.get(`${api}/${id}`)

/**
 * @description POST /license-periods
 * @returns {AxiosPromise<any>}
 */
export const CREATE_LICENSE_PERIOD = payload => request.post(api, payload)

/**
 * @description PUT /license-periods/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_LICENSE_PERIOD = (id, payload) => request.put(`${api}/${id}`, payload)

/**
 * @description POST /license-periods/{id}
 * @returns {AxiosPromise<any>}
 */
export const FINALIZE_OR_DISMISS_LICENSE_PERIOD = (id, payload) => request.post(`${api}/${id}`, payload)

/**
 * @description GET /license-periods/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_LICENSE_PERIOD_DELETE_CONFIRMATION = id => request.get(`${api}/${id}/delete-confirmation`)

/**
 * @description DELETE /license-periods/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_LICENSE_PERIOD = id => request.delete(`${api}/${id}`)
